/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdTicketPostRequest model module.
 * @module model/CustomersIdTicketPostRequest
 * @version 1.0.0
 */
class CustomersIdTicketPostRequest {
    /**
     * Constructs a new <code>CustomersIdTicketPostRequest</code>.
     * @alias module:model/CustomersIdTicketPostRequest
     * @param to {String} 
     * @param subject {String} 
     * @param category {String} 
     * @param message {String} 
     */
    constructor(to, subject, category, message) { 
        
        CustomersIdTicketPostRequest.initialize(this, to, subject, category, message);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, to, subject, category, message) { 
        obj['to'] = to;
        obj['subject'] = subject;
        obj['category'] = category;
        obj['message'] = message;
    }

    /**
     * Constructs a <code>CustomersIdTicketPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdTicketPostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersIdTicketPostRequest} The populated <code>CustomersIdTicketPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdTicketPostRequest();

            if (data.hasOwnProperty('to')) {
                obj['to'] = ApiClient.convertToType(data['to'], 'String');
            }
            if (data.hasOwnProperty('subject')) {
                obj['subject'] = ApiClient.convertToType(data['subject'], 'String');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdTicketPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdTicketPostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersIdTicketPostRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['to'] && !(typeof data['to'] === 'string' || data['to'] instanceof String)) {
            throw new Error("Expected the field `to` to be a primitive type in the JSON string but got " + data['to']);
        }
        // ensure the json data is a string
        if (data['subject'] && !(typeof data['subject'] === 'string' || data['subject'] instanceof String)) {
            throw new Error("Expected the field `subject` to be a primitive type in the JSON string but got " + data['subject']);
        }
        // ensure the json data is a string
        if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
            throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}

CustomersIdTicketPostRequest.RequiredProperties = ["to", "subject", "category", "message"];

/**
 * @member {String} to
 */
CustomersIdTicketPostRequest.prototype['to'] = undefined;

/**
 * @member {String} subject
 */
CustomersIdTicketPostRequest.prototype['subject'] = undefined;

/**
 * @member {String} category
 */
CustomersIdTicketPostRequest.prototype['category'] = undefined;

/**
 * @member {String} message
 */
CustomersIdTicketPostRequest.prototype['message'] = undefined;






export default CustomersIdTicketPostRequest;

